/** @jsx jsx */
import { jsx } from '@emotion/core'
import React, { Fragment, useState } from 'react'
import useRootStore from '@store/useRootStore'
import { observer } from 'mobx-react'
import * as _ from 'lodash'
import MessageContentPopup from '@views/Popup/MessageContentPopup'
// import { Drawer } from 'antd'
// icon
import { WriteMessageIco } from '@shared/Icon/MessageIcon'
// css
import { Button } from '@styles/button.style'
import { showToast, TOAST_TYPE } from '@utils/utils'
import { MessageSendBtnStyle } from './index.style'

import MessageTab from './MessageTab'
import { FROM_VIEW_TYPE, GlobalStoreKey } from '@v2/constants/common'


interface MessagePopupProps {
  visible?: boolean
  setVisible?: (arg: boolean) => void
  clubId?: string
}

const MessagePopup: React.FC<MessagePopupProps> = (props: MessagePopupProps) => {
  const {
    globalStore, bettingHistoryStore, matchupStore, authStore, componentStore,
  } = useRootStore()
  const { clubMessageMode } = globalStore
  const [visibleContent, setVisibleContent] = useState(false)

  const fromViewType = FROM_VIEW_TYPE.MESSAGE

  const getInitialClubId = () => {
    const { club } = matchupStore
    if (!_.isEmpty(club)) {
      return club.id
    }

    if (!_.isEmpty(authStore?.userInfo?.clubId)) {
      return authStore.userInfo.clubId
    }

    const representativeClubId = globalStore.findGlobalSetting(GlobalStoreKey.REPRESENTATIVE_CLUB)?.value
    if (!_.isEmpty(representativeClubId)) {
      return representativeClubId
    }

    return null
  }

  const onShowContent = () => {
    if (clubMessageMode && _.isEmpty(componentStore.extraClubId)) {
      showToast(TOAST_TYPE.INFO, '선택된 클럽이 없습니다. 필터를 통해 클럽을 선택해주세요.')
      return
    }

    bettingHistoryStore.resetSelectedBettingHistory(fromViewType)
    bettingHistoryStore.setBettingHistoryInitProps({ onlyMajorClub: false, fromViewType })
    setVisibleContent(true)
  }

  return (
    <Fragment>
      <MessageTab getInitialClubId={getInitialClubId}/>
      <Button css={MessageSendBtnStyle} onClick={onShowContent}>
        <WriteMessageIco/>
      </Button>

    {/* 메시지 보내기 팝업 */}
    <MessageContentPopup visible={visibleContent} setVisible={setVisibleContent} useRequestWaitTimer
                         fromViewType={fromViewType}/>
    </Fragment>
  )
}
export default observer(MessagePopup)
